import { FuseLoadable } from "@fuse";
import React from 'react';

export const SetupEmpresasConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/setupempresas',
            component: FuseLoadable({
                loader: () => import('./SetupEmpresasApp')
            })
        }
    ]
};
